import { Skeleton, Theme } from "@outschool/backpack";
import { useIsMobile } from "@outschool/ui-utils";
import * as React from "react";

export const SearchListingSkeleton = () => {
  const isMobile = useIsMobile();

  return (
    <Skeleton
      variant={isMobile ? "rectangular" : "circular"}
      sx={(theme: Theme) => ({
        width: "100%",
        height: "10rem",
        [theme.breakpoints.up("md")]: {
          borderRadius: "1.5rem",
          margin: "1.5rem auto",
          width: "90%",
          height: "25rem",
        },
      })}
    />
  );
};
